/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Empty_AllInputs */

const cs_messages_empty_all = /** @type {(inputs: Messages_Empty_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné zprávy z portálů ani webu.`)
};

const en_messages_empty_all = /** @type {(inputs: Messages_Empty_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No portal or website messages yet.`)
};

/**
* | output |
* | --- |
* | "No portal or website messages yet." |
*
* @param {Messages_Empty_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_empty_all = /** @type {((inputs?: Messages_Empty_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Empty_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_empty_all(inputs)
	return cs_messages_empty_all(inputs)
});